import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AppointmentsPage.css';

const API_URL = '/api';

export default function AppointmentsPage() {
  const [appointments, setAppointments] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [form, setForm] = useState({ title: '', description: '', start_at: '', end_at: '', contact_id: '', task_id: '' });
  const [view, setView] = useState('calendar'); // 'list' or 'calendar'
  const [showForm, setShowForm] = useState(false); // hide create form by default
  const [currentMonth, setCurrentMonth] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [aRes, cRes, tRes] = await Promise.all([
        axios.get(`${API_URL}/appointments`),
        axios.get(`${API_URL}/contacts`),
        axios.get(`${API_URL}/tasks`)
      ]);
      setAppointments(aRes.data);
      setContacts(cRes.data);
      setTasks(tRes.data);
    } catch (err) {
      console.error(err);
      alert('Erreur chargement données');
    }
  };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title || !form.start_at) return alert('Titre et date de début requis');
    try {
      await axios.post(`${API_URL}/appointments`, form);
      setForm({ title: '', description: '', start_at: '', end_at: '', contact_id: '', task_id: '' });
      setShowForm(false);
      setSelectedDay(null);
      loadData();
    } catch (err) {
      console.error(err);
      alert('Erreur création rendez-vous');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce rendez-vous ?')) return;
    try {
      await axios.delete(`${API_URL}/appointments/${id}`);
      loadData();
    } catch (err) {
      console.error(err);
      alert('Erreur suppression');
    }
  };

  // Calendar helpers
  const startOfMonth = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
  const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);
  const prevMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  const nextMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
  const localKey = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

  const appointmentsByDay = () => {
    const map = {};
    appointments.forEach(a => {
      // parse without forcing UTC to preserve local day
      const d = a.start_at ? new Date(a.start_at) : null;
      if (!d || isNaN(d.getTime())) return;
      const key = localKey(d);
      map[key] = map[key] || [];
      map[key].push(a);
    });
    return map;
  };
  const [selectedDay, setSelectedDay] = useState(null);
  // helper to format local time HH:MM
  const fmtTime = (d) => {
    if (!d) return '';
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return '';
    const hh = pad(dt.getHours());
    const mm = pad(dt.getMinutes());
    return `${hh}:${mm}`;
  };
  const displayedAppointments = selectedDay ? appointments.filter(a => {
    const d = a.start_at ? new Date(a.start_at) : null;
    if (!d || isNaN(d.getTime())) return false;
    return localKey(d) === selectedDay;
  }) : appointments;

  return (
    <div className="appointments-page">
      <div className="appointments-header">
        <h2>📅 Agenda</h2>
      </div>

      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <h3>Nouvel élément</h3>
        <div className="view-toggle">
          <button className={`btn ${view==='calendar' ? 'btn-primary' : ''}`} onClick={() => { setSelectedDay(null); setView('calendar'); }}>Calendrier</button>
          <button className={`btn ${view==='list' ? 'btn-primary' : ''}`} onClick={() => { setSelectedDay(null); setView('list'); }}>Liste</button>
        </div>
      </div>

      {showForm && (
        <form className="appointment-form card" onSubmit={handleSubmit}>
        <div className="form-row">
          <label>Titre</label>
          <input name="title" value={form.title} onChange={handleChange} required />
        </div>
        <div className="form-row">
          <label>Description</label>
          <input name="description" value={form.description} onChange={handleChange} />
        </div>
        <div className="form-row">
          <label>Début</label>
          <input type="datetime-local" name="start_at" value={form.start_at} onChange={handleChange} required />
        </div>
        <div className="form-row">
          <label>Fin</label>
          <input type="datetime-local" name="end_at" value={form.end_at} onChange={handleChange} />
        </div>
        <div className="form-row">
          <label>Contact</label>
          <select name="contact_id" value={form.contact_id} onChange={handleChange}>
            <option value="">— Aucun —</option>
            {contacts.map(c => <option key={c.id} value={c.id}>{c.name} {c.company ? `(${c.company})` : ''}</option>)}
          </select>
        </div>
        <div className="form-row">
          <label>Tâche</label>
          <select name="task_id" value={form.task_id} onChange={handleChange}>
            <option value="">— Aucune —</option>
            {tasks.map(t => <option key={t.id} value={t.id}>{t.title}</option>)}
          </select>
        </div>
        <div className="form-row">
          <button className="btn btn-primary" type="submit">💾 Enregistrer</button>
          <button type="button" className="btn" style={{marginLeft:8}} onClick={() => { setShowForm(false); setSelectedDay(null); setForm({ title: '', description: '', start_at: '', end_at: '', contact_id: '', task_id: '' }); }}>Annuler</button>
        </div>
        </form>
      )}

      {view === 'list' && (
        <div className="appointments-list">
          {displayedAppointments.map(a => (
            <div key={a.id} className="appointment-card card">
              <div className="appointment-left">
                <div className="appointment-title">{a.title}</div>
                <div className="muted">{a.contact_name || '—'} • {a.task_title || '—'}</div>
              </div>
              <div className="appointment-right">
                <div className="appointment-time">{a.start_at}{a.end_at ? ` — ${a.end_at}` : ''}</div>
                <button className="btn btn-danger" onClick={() => handleDelete(a.id)}>Supprimer</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {view === 'calendar' && (
        <div className="appointments-calendar card">
          <div className="calendar-header">
            <button className="btn" onClick={prevMonth}>◀</button>
            <strong style={{margin:'0 12px'}}>{currentMonth.toLocaleString(undefined, { month: 'long', year: 'numeric' })}</strong>
            <button className="btn" onClick={nextMonth}>▶</button>
          </div>
          <div className="calendar-grid">
            {['Lun','Mar','Mer','Jeu','Ven','Sam','Dim'].map(d => (
              <div key={d} className="calendar-cell calendar-cell-header">{d}</div>
            ))}
            {(() => {
              const start = startOfMonth(currentMonth);
              const end = endOfMonth(currentMonth);
              const startWeekDay = (start.getDay() + 6) % 7; // make Monday=0
              const days = [];
              for (let i = 0; i < startWeekDay; i++) days.push(null);
              for (let d = 1; d <= end.getDate(); d++) days.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), d));
              while (days.length % 7 !== 0) days.push(null);
              const byDay = appointmentsByDay();
              return days.map((dt, idx) => {
                if (!dt) return <div key={idx} className="calendar-cell calendar-cell-empty" />;
                const dayKey = localKey(dt);
                const items = byDay[dayKey] || [];
                return (
                    <div key={idx} className="calendar-cell" onClick={() => { 
                        // when clicking empty day, open create form prefilling start_at
                        setSelectedDay(dayKey); 
                        // open creation form and prefill start_at to that day at 09:00 local
                        const parts = dayKey.split('-');
                        const yyyy = parseInt(parts[0],10), mm = parseInt(parts[1],10)-1, dd = parseInt(parts[2],10);
                        const defaultStart = new Date(yyyy, mm, dd, 9, 0, 0);
                        // format for datetime-local: YYYY-MM-DDTHH:MM
                        const ds = `${yyyy}-${pad(mm+1)}-${pad(dd)}T${pad(defaultStart.getHours())}:${pad(defaultStart.getMinutes())}`;
                        setForm({ ...form, start_at: ds, end_at: '', title: '', description: '', contact_id: '', task_id: '' });
                        setShowForm(true); 
                        setView('calendar');
                      }} style={{cursor:'pointer'}}>
                      <div className="calendar-day-number">{dt.getDate()}</div>
                      <div className="calendar-events">
                        {items.slice(0,3).map(it => (
                          <div key={it.id} className="calendar-event" title={it.title}>{`${fmtTime(it.start_at)} ${it.title}`}</div>
                        ))}
                        {items.length > 3 && <div className="calendar-more">+{items.length - 3}</div>}
                      </div>
                    </div>
                );
              });
            })()}
          </div>
        </div>
      )}
      
    </div>
  );
}
